define('SageDotCom/Components/AgnosticProductCard/AgnosticProductCardContainer',["jquery",
    "eventManager",
    "SageDotCom/DataLayer/Events/product-card-detail",
    "SageDotCom/DataLayer/Events/DynamicProductModal",
    "SageDotCom/Utility/sanitizer",
    "SageDotCom/Utility/sageMatchHeight",
    'visitorIdCookie'],
    function ($, eventManager, ProductCardDetailEvent, modalEvents, sanitizer,  SageMatchHeight) {
        function AgnosticProductCardContainer(
            scope
        ) {
            //start common variables
            const $scope = $(scope);

            const matchElementHeights = function () {
                if (!window.AdjustingAgnosticCards) {
                    window.AdjustingAgnosticCards = true;

                    SageMatchHeight.prototype.agnosticProductCardBindings(true, { byRow: true });

                    window.AdjustingAgnosticCards = false;
                }
            }

            const deferredFunction = function () {
                SageMatchHeight.prototype.updateAllHeights();
            }

            $(window).on("resize", deferredFunction);

            // use when html structure has changed (eg. new tag created/removed in js)
            eventManager.subscribe("adjust-agnostic-cards", matchElementHeights);

            // use when just trying to update the heights (eg. price/promotion has loaded)
            eventManager.subscribe("refresh-agnostic-cards", deferredFunction);

            //Run the function
            matchElementHeights();
        }

        AgnosticProductCardContainer.init = (args) => {
            return args.IsEditorEditing === true
                ? null
                : new AgnosticProductCardContainer(
                    args.scope
            );
        };

        return AgnosticProductCardContainer;
    });

